export const formErrorPayload = (field = '', mappingKey = 'formError') => {
  return {
    API: '',
    category: 'self serve',
    code: '',
    message: '',
    type: 'form',
    field,
    mappingKey,
  };
};

export const modalPageView = (name = '', hierarchy = '') => {
  return {
    name,
    hierarchy: ['myaccount', `${hierarchy}`],
    url: 'modal-popup',
  };
};

export const page = (name = '', hierarchy = '') => {
  return {
    name,
    hierarchy: ['myaccount', 'payments', `${hierarchy}`],
  };
};

export const selfServe = (name = '', type = 'transaction') => {
  return {
    name,
    type,
  };
};
